import { type ComponentProps } from 'react';
import { Chip as HeroChip } from '@heroui/react';
import { cn } from '../utils';

export type BadgeProps = ComponentProps<typeof HeroChip>;

export const Badge = ({
  className,
  color = 'default',
  size = 'sm',
  variant = 'soft',
  ...props
}: BadgeProps) => (
  <HeroChip
    className={cn('font-medium', className)}
    color={color}
    size={size}
    variant={variant}
    {...props}
  />
);

export const Chip = Badge;
